import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { CUIStack } from '../CUIStack/CUIStack';
import { CUIFlex, CUISpacer } from '../CUIFlex/CUIFlex';
import { CUICardBody } from '../CUICard/CUICard';
import { CUIHeading } from '../CUIHeading/CUIHeading';
import CUIText from '../CUIText/CUIText';
import CUIHomepageComingSoonTag from './CUIHomepageComingSoonTag';

const CUIHomepageCardDescriptionSection = (_ref) => {
  let {
    headingText,
    bodyText,
    isComingSoon,
    cta
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["headingText", "bodyText", "isComingSoon", "cta"]);

  return /*#__PURE__*/_jsx(CUIStack, Object.assign({
    width: {
      base: '100%',
      md: '50%'
    }
  }, rest, {
    children: /*#__PURE__*/_jsx(CUICardBody, {
      padding: 12,
      children: /*#__PURE__*/_jsxs(CUIFlex, {
        direction: "column",
        height: "100%",
        align: "start",
        children: [isComingSoon && /*#__PURE__*/_jsx(CUIHomepageComingSoonTag, {
          marginBottom: "2"
        }), /*#__PURE__*/_jsx(CUIHeading, {
          size: {
            base: 'xl',
            lg: '2xl'
          },
          children: headingText
        }), /*#__PURE__*/_jsx(CUISpacer, {}), /*#__PURE__*/_jsx(CUIText, {
          py: "5",
          children: bodyText
        }), /*#__PURE__*/_jsx(CUISpacer, {}), cta]
      })
    })
  }));
};

export default CUIHomepageCardDescriptionSection;